import React from 'react';

import { UP, DOWN, LEFT, RIGHT } from './styled';

const getArrow = direction => {
  switch (direction) {
    case 'up':
      return UP;
    case 'down':
      return DOWN;
    case 'left':
      return LEFT;
    default:
      return RIGHT;
  }
};

const Arrow = ({ direction, ...rest }) => {
  const Container = getArrow(direction);

  return <Container data-testid="arrow" {...rest} />;
};

export default Arrow;
